import { useState } from 'react';
import { Link } from 'react-router-dom';

// Dismissible banner announcing that the October 2026 Marketing in a Box is
// open for ordering. Modelled on VersionBanner / MiabAnnouncementBanner.
//
// Unlike the survey banner this one is a fixed-length push rather than a
// window driven by DB state, so the expiry is a hard timestamp: marketing
// asked for 72 hours of visibility. It retires itself at EXPIRES_AT so nobody
// has to remember to take it down. If the release is promoted later than
// planned and you want the full 72 hours from go-live, push EXPIRES_AT out and
// ship a follow-up release — the banner never needs a manual takedown.
//
// Dismissal is per-browser; the announcement page stays reachable regardless.
const EXPIRES_AT = Date.parse('2026-08-06T18:00:00Z'); // 72h from the 2026-08-03 build
const DISMISS_KEY = 'amada_miab_order_banner_dismissed_oct2026';
const ANNOUNCEMENT_PATH = '/announcements/october-2026-miab';

export default function MiabOrderBanner() {
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (Date.now() > EXPIRES_AT) return null;
  if (dismissed) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* ignore storage errors — banner just won't persist dismissal */
    }
    setDismissed(true);
  };

  return (
    <div className="miab-order-banner" role="status">
      <span className="miab-order-banner-icon" aria-hidden="true">
        🎃
      </span>
      <span className="miab-order-banner-text">
        <strong>October&rsquo;s Marketing in a Box</strong> is now available to order — filled first
        come, first served.{' '}
        <Link to={ANNOUNCEMENT_PATH} className="miab-order-banner-link">
          See what&rsquo;s in the box
        </Link>
      </span>
      <button
        type="button"
        className="miab-order-banner-close"
        onClick={dismiss}
        aria-label="Dismiss announcement"
        title="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
